import { AuthService } from '../types';
import { getConfig } from '../utils';

import * as mock from './mockCognito';
import * as cognito from './cognito';

const useMockCognito = getConfig('REACT_APP_USE_MOCK_COGNITO') === 'true';

export default function getAuthModule(): AuthService {
  if (useMockCognito) {
    // tslint:disable:no-console
    console.warn('Mock cognito auth module loaded...');
    return mock;
  }
  return cognito;
}

export * from './common';
